module.exports = __webpack_public_path__ + "static/img/logo@2x.dbb71c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile/logo@2x.png
// module id = ftUl
// module chunks = 1